<template>
    <div class="member_index">
        <el-form label-position="right" label-width="90px" :model="formpwd" :rules="rules" ref="formpwd" autocomplete="off">
            <el-form-item label="旧密码" prop="old_password">
                <el-input v-model="formpwd.old_password" type="password"></el-input>
            </el-form-item>
            <el-form-item label="新密码" prop="password">
                <el-input v-model="formpwd.password" type="password"></el-input>
            </el-form-item>
            <el-form-item label="确认密码" prop="password2">
                <el-input v-model="formpwd.password2" type="password"></el-input>
            </el-form-item>
            <el-form-item>
                <el-button class="btn" type="primary" @click="submitForm('formpwd')">确定</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>    
    import { mapGetters } from 'vuex';    
    import { changePwd } from '@/api/user.js';
    export default {
        data() {
            var validatePass2 = (rule, value, callback) => {
                if (value === '') {
                    callback(new Error('请输入确认密码'));
                } else if (value !== this.formpwd.password) {
                    callback(new Error('两次输入密码不一致!'));
                } else {
                    callback();
                }
            };
            return {
                formpwd: {
                    old_password: '',
                    password: '',
                    password2: ''
                },
                rules: {
                    old_password: [
                        { required: true, message: '请输入旧密码', trigger: 'blur' },
                    ],
                    password: [
                        { required: true, message: '请输入新密码', trigger: 'blur' }
                    ],
                    password2: [
                        { required: true, message: '请输入确认密码', trigger: 'blur' },
                        { validator: validatePass2, trigger: 'blur' }
                    ]
                },
                loading: false
            };
        },        
        computed: {
            ...mapGetters(['token'])
        },
        methods: {
            submitForm(formName) {
                if (this.loading) {
                    return 0;
                }
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        this.loading = true;
                        changePwd(this.formpwd.old_password,this.formpwd.password,this.formpwd.password2).then((response)=>{
                            this.loading = false;
                            if (response.data.code == 200) {
                                this.$message({
                                    message: response.data.msg,
                                    type: 'success'
                                });
                                this.formpwd = {
                                    old_password: '',
                                    password: '',
                                    password2: ''
                                }
                            }else {
                                this.$alert(response.data.msg);
                            }
                        })
                    } else {
                        return false;
                    }
                });
            },
        }
    }
</script>

<style lang="scss">
    .member_index {        
        width: 410px;
        margin: 100px auto 0;
        .el-form-item__label {
            color: #88522a;
            font-size: 16px;
        }
        .btn {
            width: 320px;
            height: 48px;
            line-height: 48px;
            box-sizing: border-box;
            background: linear-gradient(#BC8533, #9A681F);
            color: #fff;
            border: 0 none;
            padding: 0;
            font-size: 18px;
            &:hover {
                background: linear-gradient(#9A681F, #BC8533);
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/member/index.vue